var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"to":"/Proben"}},[_c('v-card-title',[_c('v-img',{attrs:{"src":"/images/Mitglieder_Aufruf2.png","alt":"MitgliederAufruf"}})],1),_c('v-card-text',[_c('small',[_vm._v("Für Details klicken")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }